import { Button, Tab, Tabs, TextField } from "@mui/material";
import * as React from "react";
import { ViewShoppingCartBtnProps } from "../../dynamic/ViewShoppingCartBtn";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { Stack } from "@mui/system";
import { IAuthUserFormInput } from "../../../../utils/interfaces/core/AuthUser";
import { useXoraiaValue } from "../../../../hooks/useXoraia";

interface IField {
  name: "email" | "password" | "fullname" | "phone" | "confirm";
  label: string;
}

const Auth: React.FC<ViewShoppingCartBtnProps> = ({}) => {
  const { apiFetcher, userId } = useXoraiaValue();
  const [tab, setTab] = React.useState<"login" | "signup">("login");

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IAuthUserFormInput>({
    defaultValues: {
      fullname: "",
      phone: "",
      email: "",
      password: "",
      confirm: "",
    },
  });

  const onSubmit: SubmitHandler<IAuthUserFormInput> = async (data) => {
    if (!apiFetcher || !apiFetcher.setAuthUser) return;

    try {
      const user = await apiFetcher.setAuthUser(data);

      console.log("USER =>", user);
    } catch (error) {
      console.error("AUTH ERROR", error);
    }
  };

  const logOut = async () => {
    if (!apiFetcher || !apiFetcher.setAuthUser) return;

    try {
      await apiFetcher.setAuthUser(null);

      console.log("USER LOGGED OUT");
    } catch (error) {
      console.error("AUTH ERROR", error);
    }
  };

  let fields: IField[] = [
    { name: "email", label: "Address Email" },
    { name: "password", label: "Mot de Passe" },
  ];

  if (tab === "signup") {
    fields = [
      { name: "fullname", label: "Nom Complet" },
      { name: "phone", label: "Numero de Telephone" },
      ...fields,
      { name: "confirm", label: "Mot de Passe" },
    ];
  }

  if (userId) {
    return (
      <React.Fragment>
        <p>user {userId} Looged in</p>

        <Button
          disableElevation
          sx={{ m: 2 }}
          size="large"
          variant="contained"
          color="error"
          onClick={logOut}
        >
          DECONNECTION
        </Button>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Tabs variant="fullWidth" value={tab} onChange={(_, v) => setTab(v)}>
        <Tab value={"login"} label="Connexion" />
        <Tab value={"signup"} label="Inscription" />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack px={2} pt={2} spacing={2}>
          {fields.map(({ name, label }) => (
            <Controller
              key={name}
              name={name}
              control={control}
              rules={{
                required: { message: `${label} requis`, value: true },
              }}
              render={({ field }) => (
                <TextField
                  required
                  label={label}
                  fullWidth
                  variant="standard"
                  placeholder={`Entrez Votre ${label}`}
                  type={
                    ["email", "password"].includes(name)
                      ? name
                      : name === "confirm"
                      ? "password"
                      : name === "phone"
                      ? "tel"
                      : "text"
                  }
                  {...field}
                  error={!!errors[name]}
                  helperText={errors[name]?.message}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          ))}
        </Stack>
        <Button
          type="submit"
          disableElevation
          sx={{ m: 2 }}
          size="large"
          variant="contained"
          color="primary"
        >
          ME CONNECTER
        </Button>
      </form>
    </React.Fragment>
  );
};

export default Auth;
